module.exports = __webpack_public_path__ + "media/a3.ca81298f.wav";